import { connect } from 'react-redux';
import chromeExtensionSelector from 'selectors/chromeExtension';
import Actions from 'actions/presentation';
import ChromeExtension from 'components/ChromeExtension';
import { StateProps, DispatchProps } from 'components/ChromeExtension';

const ExtensionContainer = connect<StateProps, DispatchProps>(chromeExtensionSelector, {
  onCancelClick: Actions.dismissExtensionInstall,
  onInstallClick: Actions.goToStoreAndWaitForInstall
})(ChromeExtension);

export default ExtensionContainer;



// WEBPACK FOOTER //
// ./src/containers/ChromeExtension.ts